export const conversationsKeys = {
  all: ["conversations"] as const,
  details: () => [...conversationsKeys.all, "detail"] as const,
  detail: (conversationId: string) =>
    [...conversationsKeys.details(), conversationId] as const,
}
